import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  PayPalMessages,
  usePayPalScriptReducer,
} from '@paypal/react-paypal-js';
import { useMst } from '../../../models/stores/Root';

const PayPalMessagesContainer: React.FC = observer(() => {
  const { cart, configuration } = useMst();
  const [{ isPending }] = usePayPalScriptReducer();

  return !configuration.features.enablePayPalPpcp ||
    !configuration.paypalExpress.showMessaging ||
    !configuration.paypalExpress.showCreditButtons ||
    isPending ? null : (
    <div
      style={{ width: '100%', maxWidth: '250px' }}
      className="paypal-message-wrapper rounded-md flex items-center"
    >
      <PayPalMessages
        forceReRender={[cart.totals.grandTotal]}
        amount={cart.totals.grandTotal.toFixed(2)}
      />
    </div>
  );
});

export default PayPalMessagesContainer;
